import type { ReactNode } from 'react'

import { AgencyCreateEditView } from './agency-create-edit.view'

export const AgenciesCreatePage = (): ReactNode => <AgencyCreateEditView />
